<template>
  <div>
    <v-dialog v-model="showWindow" scrollable max-width="80%" persistent>
      <v-card>
        <v-card-actions>
          <h3
            class="pl-2"
            v-html="
              emptyGoodsRelocation.id
                ? $t('goods.relocation') +
                  ' #' +
                  emptyGoodsRelocation.human_number
                : $t('goods.new_relocation')
            "
          ></h3>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="close"
            :disabled="savingInProgress"
            :loading="savingInProgress"
          >
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <v-form ref="goodsRelocationForm" :disabled="isDisabledForm">
            <v-select
              outlined
              class="mt-2"
              :items="users"
              :label="$t('common.responsible')"
              item-text="name"
              :loading="!isFetchedUsers"
              v-model="emptyGoodsRelocation.responsible_for"
              return-object
              hide-details="auto"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
            ></v-select>
          </v-form>
          <goods-relocation-list
            :items="emptyGoodsRelocation.items"
            :disabled="isDisabledForm || !emptyGoodsRelocation.id"
            @add="addItems"
            @change="changeItem"
            @replace="replaceItem"
            @remove="removeItem"
            @changeGoodsListValidation="changeGoodsListValidation"
            :document-tax-value="emptyGoodsRelocation.document_tax_value"
          />
        </v-card-text>
        <v-divider class=""></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="
              emptyGoodsRelocation && emptyGoodsRelocation.id && !isDisabledForm
            "
            class="white--text"
            elevation="0"
            color="primary"
            @click="saveGoodsMovement(true)"
            :disabled="
              isEmptyItemsArray ||
              savingInProgress ||
              !isFetchedUsers ||
              !isFetchedGoodsMovementDocumentTypes
            "
            :loading="savingInProgress"
          >
            {{ $t("goods.save_and_record") }}
          </v-btn>

          <v-btn
            v-if="
              emptyGoodsRelocation &&
              emptyGoodsRelocation.id &&
              emptyGoodsRelocation.is_active == 1
            "
            class="white--text"
            elevation="0"
            color="primary"
            @click="cancelRecord"
            :disabled="
              savingInProgress ||
              !isFetchedUsers ||
              !isFetchedGoodsMovementDocumentTypes
            "
            :loading="savingInProgress"
          >
            {{ $t("goods.cancel_record") }}
          </v-btn>

          <v-btn
            v-if="
              emptyGoodsRelocation &&
              emptyGoodsRelocation.id &&
              emptyGoodsRelocation.is_active !== 1
            "
            class="white--text"
            elevation="0"
            color="primary"
            @click="saveGoodsMovement(false)"
            :disabled="
              savingInProgress ||
              !isFetchedUsers ||
              !isFetchedGoodsMovementDocumentTypes ||
              isDisabledForm
            "
            :loading="savingInProgress"
          >
            {{ $t("common.save_changes") }}
          </v-btn>
          <v-btn
            class="white--text"
            elevation="0"
            color="red"
            @click="close"
            :disabled="savingInProgress"
            :loading="savingInProgress"
          >
            {{ $t("common.close") }}
          </v-btn>
          <template
            v-if="
              emptyGoodsRelocation && emptyGoodsRelocation.id == null && !id
            "
          >
            <v-btn
              color="primary"
              elevation="0"
              @click="createGoodsRelocation()"
              :disabled="
                savingInProgress ||
                isDisabledForm ||
                !isFetchedGoodsMovementDocumentTypes
              "
              :loading="
                savingInProgress ||
                isDisabledForm ||
                !isFetchedGoodsMovementDocumentTypes
              "
            >
              {{ $t("common.create") }}
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
import SupplierSelectorWindow from "../common/SupplierSelectorWindow";
import DatePicker from "@/components/common/DatePicker";
import GoodsList from "@/components/storage/GoodsList";
import Vue from "vue";
import GoodsRelocationList from "@/components/storage/GoodsRelocationList";

export default {
  name: "GoodsRelocationForm",
  components: {GoodsRelocationList, GoodsList, DatePicker, SupplierSelectorWindow },
  mixins: [CommonMixin],
  props: {
    id: null,
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    type: "goods_relocation",
    isValidGoodsList: false,
    tabIndex: 0,
    todayDate: null,
    isVisibleSupplierSelector: false,
    emptyGoodsItem: {
      nomenclature: {},
    },
    emptyGoodsRelocation: {
      id: null,
      type: null,
      is_active: null,
      goods_movement_document_type: null,
      supplier: null,
      responsible_for: null, //ответственный
      date: null, //дата документа
      barcode: null,
      supply_document_number: null, //дата документа поставщика
      supplier_bill_number: null,
      supplier_bill_date: null,
      document_tax_value: null,
      comment: null,
      items: [],
    },
    taxes: [
      {
        name: "10%",
        value: 10,
      },
      {
        name: "18%",
        value: 18,
      },
      {
        name: "20%",
        value: 20,
      },
      {
        name: "common.no_nds",
        value: 0,
      },
    ],
  }),
  methods: {
    changeItem(item) {
      let tmp = JSON.parse(JSON.stringify(this.emptyGoodsRelocation));
      let itemForChange = tmp.items.find((el) => {
        return (
          (el.id === item.id || !el.id) &&
          el.nomenclature_id === item.nomenclature_id &&
          el.brand === item.brand &&
          el.part_code === item.part_code &&
          el.part_name === item.part_name
        );
      });
      if (itemForChange) {
        itemForChange = { ...item };
      }
      this.emptyGoodsRelocation = tmp;
    },
    replaceItem(data) {
      let tmp = JSON.parse(JSON.stringify(this.emptyGoodsRelocation));
      let itemForChange = tmp.items.find((el) => {
        return (
          (el.id === data.from.id || !el.id) &&
          el.nomenclature_id === data.from.nomenclature_id &&
          el.brand === data.from.brand &&
          el.part_code === data.from.part_code &&
          el.part_name === data.from.part_name
        );
      });
      if (itemForChange) {
        itemForChange.brand = data.to.brand;
        itemForChange.part_code = data.to.part_code;
        itemForChange.part_name = data.to.part_name;
        itemForChange.nomenclature_id = data.to.nomenclature_id;
        itemForChange.nomenclature = data.to;
      }
      this.emptyGoodsRelocation = tmp;
    },
    changeGoodsListValidation(data) {
      this.isValidGoodsList = data;
    },
    removeItem(item) {
      let tmp = JSON.parse(JSON.stringify(this.emptyGoodsRelocation));
      if (item) {
        let index = tmp.items.findIndex((el) => {
          return (
            (el.id === item.id || !el.id) &&
            el.nomenclature_id === item.nomenclature_id &&
            el.brand === item.brand &&
            el.part_code === item.part_code &&
            el.part_name === item.part_name
          );
        });
        if (index !== -1) {
          tmp.items.splice(index, 1);
        }
      }
      this.emptyGoodsRelocation = tmp;
    },
    addItems(items) {
      items.forEach((item)=>{
        let tmp = JSON.parse(JSON.stringify(this.emptyGoodsRelocation));
        tmp.items.unshift(item);
        this.emptyGoodsRelocation = tmp;
      })

    },
    cancelRecord() {
      //отмена проведения документа
      this.$confirm({
        title: this.$t("common.confirm"),
        text: this.$t("goods.confirm_cancel_record"),
        cancelText: this.$t("common.no"),
        acceptText: this.$t("common.yes"),
      }).then((y) => {
        this.emptyGoodsRelocation.is_active = 0;
        this.$store
          .dispatch("goods_movement_bases/update", this.emptyGoodsRelocation)
          .then((saved) => {
            if (saved) {
              this.emptyGoodsRelocation = { ...saved };
            }
          });
      });
    },
    saveGoodsMovement(is_active = false) {
      //проверим что провалидирован список товаров
      if (
        this.isValidGoodsList === false &&
        this.emptyGoodsRelocation.items &&
        this.emptyGoodsRelocation.items.length > 0
      ) {
        this.tabIndex = 1;
        return;
      }
      if (this.$refs["goodsRelocationForm"].validate()) {
        if (is_active) {
          //документ будет проведен
          this.emptyGoodsRelocation.is_active = 1;
        }
      }
      this.$store
        .dispatch("goods_movement_bases/update", this.emptyGoodsRelocation)
        .then((saved) => {
          if (saved) {
            this.emptyGoodsRelocation = { ...saved };
            this.tabIndex = 1;
          }
        });
    },
    /**
     * Установим тип документа - для перемещения он единственный - goods_relocation
     * @param goodsRelocation
     */
    setDocumentType(goodsRelocation){
      goodsRelocation.goods_movement_document_type = this.goods_movement_document_types.find((item)=>item.type === this.type)
      return goodsRelocation;
    },
    createGoodsRelocation() {

      if (this.$refs["goodsRelocationForm"].validate()) {
        this.emptyGoodsRelocation = this.setDocumentType(this.emptyGoodsRelocation)
        this.$store
          .dispatch("goods_movement_bases/store", this.emptyGoodsRelocation)
          .then((created) => {
            if (created) {
              this.emptyGoodsRelocation = created;
            }
          });
      }
    },
    close() {
      this.$refs["goodsRelocationForm"].reset();
      this.emptyGoodsRelocation = {};
      this.tabIndex = 0;
      this.showWindow = false;
    },
    setDateFromDatepicker() {
      this.isVisibleDatepickerDialog = false;
    },
    fillEmptyGoodsRelocation() {
      if (this.goods_relocation_item.id === this.id) {
        this.emptyGoodsRelocation = this.goods_relocation_item;
      }
    },
  },
  computed: {
    isEmptyItemsArray(){
      return (! this.emptyGoodsRelocation) || (! this.emptyGoodsRelocation.items) || this.emptyGoodsRelocation.items.length < 1;
    },
    isDisabledForm() {
      return (
        !this.emptyGoodsRelocation ||
        parseInt(this.emptyGoodsRelocation.is_active) === 1 ||
        this.savingInProgress
      );
    },
    ...mapFields("goods_movement_bases", [
      "savingInProgress",
      "goods_relocation_item",
    ]),
    ...mapFields("goods_movement_document_types", {
      isFetchedGoodsMovementDocumentTypes: "fetched",
    }),
    ...mapFields("goods_movement_document_types", [
      "goods_movement_document_types",
    ]),
    ...mapFields("users", ["users"]),
    ...mapFields("users", { isFetchedUsers: "fetched" }),
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$refs["goodsRelocationForm"].resetValidation();
        this.$emit("hide");
      },
    },
  },
  mounted() {
    this.emptyGoodsRelocation.type = this.type;
  },

  watch: {
    goods_relocation_item() {
      this.fillEmptyGoodsRelocation();
    },
    show(to) {
      if (to) {
        this.$store.dispatch("storages/get");
        this.$store.dispatch("goods_movement_document_types/get", {
          type: this.type,
        });
        this.$store.dispatch("users/get");
        if (this.id) {
          this.$store
            .dispatch("goods_movement_bases/getOne", {
              id: this.id,
              type: this.type,
            })
            .then(() => {
              this.fillEmptyGoodsRelocation();
            });
        } else {
          this.emptyGoodsRelocation = {};
        }
      }
    },
  },
};
</script>
